import { createFileRoute } from '@tanstack/react-router';
import { ConnectionPage } from '../../features/connections';

export const Route = createFileRoute('/portal/connections/$id')({
  component: function ConnectionRoute() {
    const { id } = Route.useParams();
    return <ConnectionPage id={id} />;
  },
});
